import * as React from "react";

export const FilterIconGrid = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#2D5BFF"
      d="M.976.014v13.75h13.75V.014H.976Zm1.25 1.25h11.25v11.25H2.226V1.264Zm8.125 1.875c-.364 0-.67.136-.918.41-.247.26-.358.573-.332.937l-2.93 1.465a1.196 1.196 0 0 0-.82-.312c-.351 0-.65.123-.898.37a1.192 1.192 0 0 0-.352.88c0 .351.118.65.352.898.247.234.547.352.898.352.313 0 .586-.104.82-.313l2.93 1.465a1.24 1.24 0 0 0 .332.957c.248.26.547.39.899.39.364 0 .664-.117.898-.35.248-.248.371-.548.371-.9a1.16 1.16 0 0 0-.37-.878 1.16 1.16 0 0 0-.88-.371c-.312 0-.586.104-.82.312l-2.93-1.465v-.195l2.93-1.465c.234.209.508.313.82.313.352 0 .645-.118.88-.352.247-.247.37-.547.37-.898a1.16 1.16 0 0 0-.37-.88 1.16 1.16 0 0 0-.88-.37Z"
    />
  </svg>
);
